module.exports = __webpack_public_path__ + "img/invalid-link.d5790851.png";